import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { sortBy } from "lodash";
import { Row } from "react-bootstrap";

import * as reportActions from "../../../actions/reportActions";
import * as projectActions from "../../../actions/projectActions";

import Loading from "../../common/Loading";

import Employee from "./Employee";
import HoursChart from "./HoursChart";

import Filters from "./EmployeeSummaryByProjectFilters";

const EmployeeSummaryByProject = ({ actions, report, loading }) => {
  useEffect(
    () => () => {
      actions.clearReport();
    },
    [actions]
  );

  return (
    <React.Fragment>
      <Filters loading={loading} />

      {loading && (
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Loading />
        </Row>
      )}

      {!loading && !!report.users.length && (
        <div className="project-employee-summary-container">
          {!!(report.calls && Object.keys(report.calls).length) && (
            <div className="content-wrapper">
              <HoursChart data={report.calls} />
            </div>
          )}
          <div className="project-employee-summary-wrapper">
            {sortBy(report.users, (user) => user.assigned_to[0]?.full_name).map(
              (user) => (
                <div key={user._id.assigned_to}>
                  <Employee employee={user} />
                </div>
              )
            )}
          </div>
        </div>
      )}

      {!loading && !report.users.length && (
        <div className="no-data">No Data Available</div>
      )}
    </React.Fragment>
  );
};

EmployeeSummaryByProject.propTypes = {
  actions: PropTypes.object,
  report: PropTypes.object,
  loading: PropTypes.bool
};

EmployeeSummaryByProject.defaultProps = {
  report: {
    users: [],
    calls: []
  },
  loading: false
};

function mapStatesToProps(state) {
  return {
    report: state.reducers.PESReport,
    loading: state.reducers.loading,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...reportActions,
        ...projectActions
      },

      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(EmployeeSummaryByProject);
